module.exports = __webpack_public_path__ + "media/images/btn_semen_cvs-58f017fe22188c48dca1103bff1ecb6b.gif";